import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Orders API functions
export const createOrder = async (orderData) => {
  try {
    // Check if orderData is FormData
    const isFormData = orderData instanceof FormData;
    const response = await axiosInstance.post(
      `${API_ROUTES.ORDERS.CREATE}/?apiCallFromAdmin=true`,
      orderData,
      isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}
    );
    return response.data;
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};

export const updateOrder = async (orderId, updateData) => {
  try {
    // Check if updateData is FormData
    const isFormData = updateData instanceof FormData;
    const response = await axiosInstance.patch(
      `${API_ROUTES.ORDERS.UPDATE}/${orderId}/?apiCallFromAdmin=true`,
      updateData,
      isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}
    );
    return response.data;
  } catch (error) {
    console.error('Error updating order:', error);
    throw error;
  }
};

export const sendDeliveryVerification = async (orderId, driverName, driverMobileNumber, driverVehicleNo) => {
  try {
    const response = await axiosInstance.post(
      `${API_ROUTES.ORDERS.DELIVERY_VERIFICATION}/${orderId}/`,
      {
        driverName,
        driverMobileNumber,
        driverVehicleNo
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error updating order:', error);
    throw error;
  }
};

export const getOrders = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams.page || 1,
      search: queryParams.search || '',
      status: queryParams.status || '',
    };
    const response = await axiosInstance.get(API_ROUTES.ORDERS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    throw error;
  }
};

export const getOrderById = async (orderId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.ORDERS.GET_SINGLE_ORDER}/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching order:', error);
    throw error;
  }
};

export const getPlacedOrderCount = async () => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.ORDERS.GET_PLACEORDER_COUNT}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching order:', error);
    throw error;
  }
};
export const getSalePersonPlacedOrderCount = async (adminUserId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.ORDERS.GET_SALEPLACEORDER_COUNT}/${adminUserId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching order:', error);
    throw error;
  }
};

export const deleteOrders = async (orderIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.ORDERS.DELETE, {
      data: {
        ids: orderIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting orders:', error);
    throw error;
  }
};

export const notifyCustomer = async (orderId) => {
  try {
    const response = await axiosInstance.post(`${API_ROUTES.ORDERS.CUSTOMER_NOTIFY}/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting orders:', error);
    throw error;
  }
}

export const notifyCustomerToEmail = async (orderId) => {
  try {
    const response = await axiosInstance.post(`${API_ROUTES.ORDERS.CUSTOMER_NOTIFY_TO_EMAIL}/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting orders:', error);
    throw error;
  }
}

export const notifyCustomerToWhatsapp = async (orderId) => {
  try {
    const response = await axiosInstance.post(`${API_ROUTES.ORDERS.CUSTOMER_NOTIFY_TO_WHATSAPP}/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting orders:', error);
    throw error;
  }
}

// Additional functions can be added here as needed